const CONST_VARIANT = {
  MUI_DEFAULT: 'MUI_DEFAULT',
  KC_DEFAULT: 'KC_DEFAULT',
  DISABLED: 'DISABLED',
}

const MUI_LICENSE = 'aae3f8c2f83f4a59db742834b56e213bTz00OTU0MixFPTE2OTI4MTkwNzQ1MzcsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y';

export { CONST_VARIANT, MUI_LICENSE };